export const statusColors = {
  online: '#52c41a',
  offline: '#666666',
  standBy: '#2db7f5',
  maintain: '#ff5500',
  error: '#ff1e00'
}

export const status = [
  {
    key: 'online',
    value: '在线',
    color: '#0eed24',
    sort: 0
  },
  {
    key: 'running',
    value: '运行',
    color: '#0eed24',
    sort: 0
  },
  {
    key: 'offline',
    value: '离线',
    color: '#4d4d4d',
    sort: 1
  },
  {
    key: 'offline',
    value: '备机',
    color: '#4d4d4d',
    sort: 1
  },
  {
    key: 'standby',
    value: '停机',
    color: '#11d7f5',
    sort: 2
  },
  {
    key: 'sleep',
    value: '待机',
    color: '#11d7f5',
    sort: 2
  },
  {
    key: 'maintain',
    value: '保养',
    color: '#ff681c',
    sort: 4
  },
  {
    key: 'error',
    value: '故障',
    color: '#e82127',
    sort: 5
  }
]